const SituacaoAvaliadoEnum = {
    SEM_RESPOSTAS: 1,
    ESPERAR_GESTOR: 2,
    ESPERAR_COLABORADOR: 3,
    FINALIZADA: 4,
    ESPERAR_FEEDBACK: 5
}

export default SituacaoAvaliadoEnum;